import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../../helpers/constants";
import useUserData from "../../../hooks/user/useUserData";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import {ALERTS} from "../../../locales/components/namespaces";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import useUserAction from "../../../hooks/user/useUserAction";

const useRights = () => {
    const {token, isLoggedIn} = useUserData()
    const {userLogout} = useUserAction()
    const {t} = useTranslation(ALERTS)
    const [loading, setLoading] = useState(false)
    const [rights, setRights] = useState([])
    const [updateRights, setUpdateRights] = useState(false)

    useEffect(() => {
        setLoading(true)
        axios({
            method: 'get',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/right/list`,
        }).then((response) => {
            setRights(response.data)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to get rights list.')), {
                    variant: 'error'
                }
            )
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }, [updateRights])

    const store = (newRow) => {
        axios({
            method: 'post',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/right/store`,
            data: newRow
        }).then(response => {
            setUpdateRights(!updateRights)
            enqueueSnackbar(t('New rights added successfully!'), {
                    autoHideDuration: 3000,
                    variant: 'success'
                }
            )
        }).catch(error => {
            setUpdateRights(!updateRights)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to store new rights!')), {
                    variant: 'error'
                }
            )
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }

    const remove = (id) => {
        axios({
            method: 'post',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/right/remove`,
            data: {
                id: id
            }
        }).then(response => {
            setUpdateRights(!updateRights)
            enqueueSnackbar(t('Rights deleted successfully!'), {
                    autoHideDuration: 3000,
                    variant: 'success'
                }
            )
        }).catch(error => {
            setUpdateRights(!updateRights)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to delete rights!')), {
                    variant: 'error'
                }
            )
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }

    return {
        loading,
        rights,
        store,
        remove
    }
}

export default useRights